import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import {ScheduleOutlined, QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import LogModal from '../components/LogModal'
import FormModal from '../components/FormModal'
import ScheduleModal from '../components/ScheduleModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {confirm} = Modal

@inject('jobManagementStore', 'mappingManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    logModalVisible: false,
    scheduleModalVisible: false,
    logType: null,
    jobId: null
  }

  componentDidMount() {
  }

  handleSchedule = (record) => {
    const {jobManagementStore} = this.props
    jobManagementStore.onGetJobAction({jobId: record.id}).then(res => {
      this.setState({
        scheduleModalVisible: true,
      })
    })
  }
  handleCancelSchedule = () => {
    this.setState({
      scheduleModalVisible: false
    })
  }
  handleLog = (record) => {
    const {jobManagementStore} = this.props
    let params = {
      'jobId': record.id,
      'page': 1,
      'size': PAGE_SIZE_DEFAULT,
    }
    jobManagementStore.onDetailsJobAction(params).then(res => {
      this.setState({
        logModalVisible: true,
        logType: record.jobType,
        jobId: record.id
      })
    })
  }
  handleCancelLog = () => {
    this.setState({
      logModalVisible: false
    })
  }
  handleEdit = (record) => {
    const {jobManagementStore, mappingManagementStore} = this.props
    jobManagementStore.onGetJobAction({jobId: record.id}).then(res => {
      if (res.jobType === '3') {
        mappingManagementStore.onGetInboundNamesAction({ids: res.inboundCustomer.join(';')}).then(() => {
          this.setState({
            addModalVisible: true,
          })
        })
      } else {
        this.setState({
          addModalVisible: true,
        })
      }
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {jobManagementStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        jobManagementStore.onDeleteJobAction({id: record.id, deleted: 1})
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {jobManagementStore} = this.props
    jobManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {jobManagementStore, mappingManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, jobType, jobStatus} = jobManagementStore
    const {inboundCustomerList, outboundCustomerList} = mappingManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}
               scroll={{x: '110%'}}>
          <Table.Column align="center" width={80} title={t(`job.status`)} dataIndex="jobStatus" key="jobStatus"
            render={(text, record, index) => {
                const statusLabel = jobStatus?.find(item => item.code === text)?.label
                return (<div style={{
                    display: 'inline-block',
                    height: 24,
                    width: 24,
                    lineHeight: '24px',
                    fontSize: 12,
                    borderRadius: 24,
                    color: 'white',
                    textAlign: 'center',
                    background: statusLabel === 'Enable' ? (themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c') : statusLabel === 'Disable' ? (themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0') : (themeStyle?.statusColor?.split(',')?.[3] || '#facb61')
                  }} title={statusLabel}>{statusLabel.charAt(0)}</div>)
              }
            }
          />
          <Table.Column title={t(`job.jobType`)} dataIndex="jobType" key="jobType" ellipsis={true}
                        render={(text, record, index) => jobType?.find(item => item.code === text)?.label}
          />
          <Table.Column title={t(`job.jobName`)} dataIndex="jobName" key="jobName" ellipsis={true}
                        render={(text, record, index) => <a onClick={() => this.handleLog(record)}>{text}</a>}
          />
          <Table.Column title={t(`job.inboundCustomer`)} dataIndex="inboundCustomer" key="inboundCustomer" ellipsis={true}
            // render={(text, record, index) => inboundCustomerList?.find(item=>item.id===text)?.customer}
                        render={(text, record, index) => {
                          const newCustomer = []
                          inboundCustomerList.forEach(item => {
                            text.split(';').forEach(subItem => {
                              if (item.id === subItem) {
                                newCustomer.push(item.customer)
                              }
                            })
                          })
                          return newCustomer.join(' ')
                        }}
          />
          <Table.Column title={t(`job.inboundName`)} dataIndex="inboundApiName" key="inboundApiName" ellipsis={true}/>
          <Table.Column title={t(`job.outboundCustomer`)} dataIndex="outboundCustomer" key="outboundCustomer" ellipsis={true}
                        render={(text, record, index) => outboundCustomerList?.find(item => item.id === text)?.customer}
          />
          <Table.Column title={t(`job.outboundName`)} dataIndex="outboundApiName" key="outboundApiName" ellipsis={true}/>
          <Table.Column width={140} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleSchedule(record)} icon={<ScheduleOutlined/>} title={t(`general.schedule`)}/>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.scheduleModalVisible ? <ScheduleModal
          scheduleModalVisible={this.state.scheduleModalVisible}
          handleCancel={this.handleCancelSchedule}
        /> : null}
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.logModalVisible ? <LogModal
          logModalVisible={this.state.logModalVisible}
          type={this.state.logType}
          jobId={this.state.jobId}
          handleCancel={this.handleCancelLog}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
